import React, { useState, useContext } from "react";

import moment from "moment";

import Items from "../Items";
import OrderDetails from "../OrderDetails";

import { ContextProvider } from "../../../App";

function DailyMenu({ selectionPlan }) {
  const tomorrow = moment().add(1, 'days').format('dddd');
  const { cartState, cartDispatch, authState } = useContext(ContextProvider);

  const [foodItems] = useState(authState.categories);
  const [selectDailyItem, setSelectDailyItem] = useState("");

  const selectDailyFood = (id, title) => {
    cartDispatch({type:"SELECT_FOOD_ITEM", tomorrow, id, title})
    const selectedItem = foodItems.filter((item) => item._id === id);
    setSelectDailyItem(selectedItem)
  }

  return (
    <>
      <div className="select_main_container">
        <div className="select_content_container">
          <div className="daily_selection_day_div">
            <p>{ tomorrow}</p>
          </div>
          <div>
            <Items foodItems={foodItems} selectionPlan={selectionPlan} selectDailyItem={selectDailyItem} selectDailyFood={selectDailyFood}/>
          </div>
          <div>
            <OrderDetails selectionPlan={selectionPlan} cartState={cartState} tomorrow={tomorrow}/>
          </div>
        </div>
      </div>
    </>
  );
}

export default DailyMenu;
